import {prefersProductDefaultScene} from "../libs/authoritativeDefaultScene";
import {resolveMergedScene} from "./default-scene-resolution";
import {resolveLegacySceneId as canonicalSceneId} from "../libs/legacySceneId";
export function resolveLegacySceneId({typeConfig, productCode, set, layout, background}) {
  return canonicalSceneId({products: typeConfig.products, defaults: typeConfig.defaults, product: productCode, set, layout, background});
}
export function resolveOverrideSceneData(overrides, {channel, productCode, contentType, set, layout, background}) {
  const scene = resolveMergedScene(overrides, channel, productCode, contentType, set, String(layout), background).sceneData;
  return scene && Object.keys(scene).length ? scene : null;
}
export function preferLegacyDefaults(productCode: string, hasPerProductOverride: boolean, legacySceneId: string | null) {
  return prefersProductDefaultScene({product: productCode, layers: hasPerProductOverride ? [{product: productCode}] : [], hasProductDefaultScene: Boolean(legacySceneId)});
}
